import type { FC } from "react"
import { useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useRequest } from "ahooks"
import { useConfigModel } from "@/models"
import { getFeijiteConfig } from "@/api"
import type { RouterIdsVO, AreaItemVO } from "@/api"
import { isShowConfig, getCurrentPageType } from "@/util/commonUtils"
// ==============================================
import Avatar from "@/components/Header/components/Avatar"
import TopDecoration from "@/components/Header/components/TopDecoration"
import AreaSelect from "@/components/Header/components/AreaSelect"
// ==============================================
const HeaderInsights: FC<any> = () => {
  const { cityId } = useParams<RouterIdsVO>() as any
  const navigate = useNavigate()
  const isShow = isShowConfig()
  const pageType = getCurrentPageType()
  const [options, setOptions] = useState<AreaItemVO[]>([])
  const { setFeijiteConfig } = useConfigModel()

  // 获取飞吉特权限
  useRequest(getFeijiteConfig, {
    onSuccess: (res) => {
      const area = res?.area?.slice() || []
      setOptions(area)
      setFeijiteConfig({
        ...res,
      })
    },
    onError: () => {
      setOptions([])
    },
  })

  // 城市下拉change
  const areaSelectChange = (areaId: number) => {
    // 跳转页面
    navigate(`/${areaId}/${pageType}`)
  }

  return (
    <>
      {/* 头像 */}
      <Avatar isShowConfig={isShow} />
      {/* 城市下拉 */}
      <AreaSelect value={Number(cityId)} options={options} onChange={areaSelectChange} />
      {/* 顶部 */}
      <TopDecoration showName="飞吉特" />
    </>
  )
}

export default HeaderInsights
